import { IParticipant } from "bets.oddprovider.lib.common.ts/models"
import { ApiClientUtils } from "fwork-jsts-common/src/apiClient"
import { useSnackbar } from "notistack"
import React, { useState } from "react"
import { FaTrash } from "react-icons/fa"
import axios from "../../apiClient/axios"
import { ParticipantsApiClient } from "../../apiClient/participants"
import { DropDownSearchComponent } from "../common/dropDownSearch"

export const EventParticipantComponent = (props: {
  initParticipant?: IParticipant,
  onSelectItem?: (item: IParticipant) => void,
  onDelete?: (item: IParticipant) => void,
}) => {

  const { enqueueSnackbar } = useSnackbar()
  const [gettingParticipants, setGettingParticipants] = useState<boolean>()

  let participants: IParticipant[] | undefined
  const getParticipants = async (filter: string | undefined) => {
    if (gettingParticipants) return
    setGettingParticipants(true)

    try {
      const response = await new ParticipantsApiClient(axios).get({
        where: {
          name: { $regex: filter || '', $options: 'i' }
        },
        sort: { name: 1 }
      })
      participants = response.data?.payload
      return participants
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    } finally {
      setGettingParticipants(false)
    }
  }

  return <>
    <DropDownSearchComponent
      initInputValue={props.initParticipant?.name || ''}
      progress={gettingParticipants}
      style={{ width: '100%' }}
      label='Participante'
      modelLabelName={"name"}
      dataBuilder={async (typedText: string | undefined) => {
        if (typedText)
          return await getParticipants(typedText)
      }}
      onSelectItem={props.onSelectItem}
    />
    <FaTrash style={{ cursor: 'pointer' }} color='grey' size={20} onClick={() => {
      if (props.onDelete && props.initParticipant)
        props.onDelete(props.initParticipant)
    }} />
  </>
}